import { ATTRIBUTE_FIELDS } from './customerProfileSearchTypes';

export default [ATTRIBUTE_FIELDS.PHONE_NUMBER, ATTRIBUTE_FIELDS.EMAIL, ATTRIBUTE_FIELDS.ACCOUNT_NUMBER];
